module.exports = __webpack_public_path__ + "static/media/clone.99853835.svg";